import templateBase from './templates/price-filter-base.view.html';
import templateAD from './templates/price-filters-adaptative.html';

function PriceFilterDirective(SessionService) {

    let response = SessionService.get('components');
    let htmlTemplate = templateBase;

    if (__env.adaptative){
        htmlTemplate = templateAD;
    }

    return {
        restrict: 'E',
        template: htmlTemplate
    };
}

PriceFilterDirective.$inject = ['SessionService'];

export default PriceFilterDirective;


// WEBPACK FOOTER //
// ./www/components/catalog/products-list/price-filter/price-filter.directive.js